module.exports = __webpack_public_path__ + "static/media/to.e6ae6616.svg";